import type { StreamEvent, TextEvent, TableEvent, EndEvent } from "./streamTypes";

export function isTextEvent(event: StreamEvent): event is TextEvent {
  return event.type === "text" && "text" in event && typeof event.text === "string";
}

export function isTableEvent(event: StreamEvent): event is TableEvent {
  return (
    event.type === "table" &&
    "title" in event &&
    "data" in event &&
    typeof event.title === "string" &&
    Array.isArray(event.data)
  );
}

export function isEndEvent(event: StreamEvent): event is EndEvent {
  return event.type === "end";
}
